import { apiQuery, createQueryKeys, useApiMutation } from '@/shared/data';

import { bankSlipOperations, getBankSlip } from './bank-slip.api';

export const bankSlipKeys = createQueryKeys('bank-slip');
export const bankSlipDetailQuery = (id: string) =>
  apiQuery(bankSlipKeys.detail(id), ({ signal }) => getBankSlip(id, signal), {
    enabled: id !== '',
  });
export type BankSlipMutationName = keyof typeof bankSlipOperations;
export type BankSlipMutationVariables<K extends BankSlipMutationName> = Parameters<
  (typeof bankSlipOperations)[K]
>[0];
export function useBankSlipMutation<K extends BankSlipMutationName>(name: K) {
  const run = bankSlipOperations[name] as (
    variables: BankSlipMutationVariables<K>,
  ) => Promise<unknown>;
  return useApiMutation({
    mutationKey: ['bank-slip', name],
    mutationFn: run,
    invalidate: [bankSlipKeys.all],
    success: false,
    error: false,
  });
}
